module.exports = __webpack_public_path__ + "static/media/img-roaming-packet.c07def07.png";